export const LandIcon: React.FC = () => {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 15L1 21.5H23L19 15H5Z"
        stroke="white"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <circle cx="9" cy="7" r="6" stroke="white" strokeWidth="1.4" />
      <path
        d="M9 7L9 17"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 8L9 9"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11L11 9"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
